<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <!--基础信息-->
      <Basic></Basic>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" >发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/lottery.js';
import Basic from './part/Basic.vue';

export default {
  components: {
    /*基础信息*/
    Basic,

  },
  data() {
    return {
      /*商品ID*/
      lottery_prize_id: 0,
      /*判断是编辑*/
      scene: 'edit',
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        model: {},
        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false
      },
      /*模型数据*/
      model: {
        'prize_name':'',
        /*商品图片*/
        image: [],
        /*奖品类型*/
        type: 10,
        /*奖品排序*/
        sort: 1,

        is_status:10,
      }
    };
  },
  provide: function() {
    return {
      form: this.form
    };
  },
  created() {
    /*获取列表*/
    this.lottery_prize_id = this.$route.query.lottery_prize_id;
    this.scene = this.$route.query.scene;
    this.getData();
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function() {
      let self = this;
      PorductApi.getPrizeData(
        {
          lottery_prize_id: self.lottery_prize_id,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false;
          self.form.model=res.data.detail;
         // Object.assign(self.form.model, res.data.detail);



        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*提交*/
    onSubmit: function() {
      let self = this;
      let params = self.form.model;
      self.$refs.form.validate(valid => {
        if (valid) {
          params.scene = self.scene;
          params.image = self.ImgKeepId(params.image);
          params.lottery_prize_id = self.lottery_prize_id;

          self.save_loading = true;
          PorductApi.prizeEdit({
             lottery_prize_id: self.lottery_prize_id,
             scene: self.scene,
             params: JSON.stringify(params)
          }, true)
            .then(data => {
              self.save_loading = false;
              self.$message({
                message: '保存成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.save_loading = false;
            });
        }
      });

    },

    /*图片数值只保留id*/
    ImgKeepId(list) {
      let arr = [];
      for (let i = 0, length = list.length; i < length; i++) {
        let obj = {
          image_id: list[i].image_id,
          file_id: list[i].file_id
        };
        arr.push(obj);
      }
      return arr;
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/prize/edit.vue